import React, { useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import { BsArrowRight, BsArrowLeft } from "react-icons/bs";

import "swiper/css";
import "swiper/css/pagination";

import image1 from "../../assets/image12.jpg";
import image2 from "../../assets/image13.png";
import image3 from "../../assets/image14.png";

const Hero = () => {
    const swiperRef = useRef(null);
    const [isBeginning, setIsBeginning] = useState(true);
    const [isEnd, setIsEnd] = useState(false);

    const handleSlideChange = () => {
        if (swiperRef.current) {
            setIsBeginning(swiperRef.current.isBeginning);
            setIsEnd(swiperRef.current.isEnd);
        }
    };

    const slides = [image1, image2, image3];

    return (
        <section className="sm:pb-16 lg:pb-40 max-w-[1920px] w-full mx-auto px-4">
            {/* Section Header */}
            <div className="pt-20 md:pt-28 max-w-7xl mx-auto">
                <h1 className="text-3xl md:text-4xl font-bold text-headings mb-4">
                    For Drivers
                </h1>
            </div>

            {/* Slider Section */}
            <div className="relative max-w-7xl mx-auto w-full h-[400px]">
                <Swiper
                    spaceBetween={20}
                    slidesPerView="auto"
                    pagination={{ clickable: true }}
                    modules={[Navigation, Pagination]}
                    onSwiper={(swiper) => (swiperRef.current = swiper)}
                    onSlideChange={handleSlideChange}
                    className="mySwiper"
                >
                    {slides.map((img, idx) => (
                        <SwiperSlide key={idx} className="swiper_slide">
                            <div className="h-[350px] sm:h-[400px] lg:h-[480px] mb-10 sm:mb-12">
                                <img
                                    src={img}
                                    alt={`slide-${idx + 1}`}
                                    className="w-full h-full object-cover"
                                    loading="lazy"
                                />
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>

                {/* Navigation Buttons */}
                <div className="flex gap-5 items-center absolute right-0 -mt-9 z-30">
                    <button
                        onClick={() => swiperRef.current?.slidePrev()}
                        disabled={isBeginning}
                        className={`text-xl sm:text-2xl transition-all duration-300 ${isBeginning ? "opacity-40 cursor-not-allowed" : "opacity-100 text-primary"
                            }`}
                    >
                        <BsArrowLeft />
                    </button>
                    <button
                        onClick={() => swiperRef.current?.slideNext()}
                        disabled={isEnd}
                        className={`text-xl sm:text-2xl transition-all duration-300 ${isEnd ? "opacity-40 cursor-not-allowed" : "opacity-100 text-primary"
                            }`}
                    >
                        <BsArrowRight />
                    </button>
                </div>
            </div>
        </section>
    );
};

export default Hero;
